module.exports = __webpack_public_path__ + "d6c3fa9b593ac6e2c9ae7b2749f3b2da.svg";